module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trabalho) ? _c('a', {
    staticClass: "trabalho",
    attrs: {
      "href": _vm.trabalho.href,
      "target": _vm.trabalho.target
    }
  }, [_c('div', {
    staticClass: "trabalho-nome"
  }, [_vm._v(_vm._s(_vm.trabalho.titulo))]), _vm._v(" "), _c('small', {
    staticClass: "trabalho-eixo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'trabalhos',
        params: {
          pesquisa: _vm.trabalho.eixo.nome
        }
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.trabalho.eixo.nome))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "trabalho-autores"
  }, [_vm._l((_vm.trabalho.todos_autores), function(a, index) {
    return [(index != 0) ? _c('span', [_vm._v(" ; ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "trabalho-autor",
      attrs: {
        "to": '/autor/' + a.id
      }
    }, [_vm._v(_vm._s(a.nome))])]
  })], 2), _vm._v(" "), (_vm.trabalho.palavras_chaves.length) ? _c('small', {
    staticClass: "trabalho-palavras-chaves"
  }, [_vm._l((_vm.trabalho.palavras_chaves), function(p, index) {
    return [(index != 0) ? [_vm._v(", ")] : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: p.palavra_chave
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(p.palavra_chave) + "\n      ")])]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "trabalho-id"
  }, [_vm._v(_vm._s(_vm.trabalho.id))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57630ea3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/anais/AnaisTrabalhoRow.vue
// module id = 213
// module chunks = 0